<template>
  <v-dialog v-model="dialog" class="mx-auto" width="300">
    <v-card>
      <v-row no-gutters>
        <v-col cols="10">
          <v-card-title>
            {{ $t("label.lang") }}
          </v-card-title>
        </v-col>
        <v-col cols="2" class="my-auto">
          <v-card-actions>
            <v-btn color="primary" small icon @click="dialog = false"
              ><v-icon>{{ mdiCloseThick }}</v-icon></v-btn
            >
          </v-card-actions>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-card-text>
        <v-radio-group v-model="langGroup">
          <v-radio
            v-for="lang in langs"
            :key="lang.id"
            :label="`${lang.name}`"
            @change="setLang(lang.id)"
          ></v-radio>
        </v-radio-group>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">
          {{ $t("label.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import { mdiCloseThick } from "@mdi/js";

export default {
  name: "language",
  created: debounce(function () {
    this.$nextTick(() => {
      let lang = localStorage.getItem("lang");
      if (lang != undefined && lang != null && lang != "") {
        this.setLang(lang);
      }
    });
  }, 250),
  data: () => ({
    langGroup: 0,
    langs: [
      { id: "zhHant", name: "繁體" },
      { id: "en", name: "English" },
    ],

    //svg icons
    mdiCloseThick,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    setLang: function (lang) {
      this.$vuetify.lang.current = lang;
      localStorage.setItem("lang", lang);
      this.$store.dispatch("setLang", lang);
    },
  },
  watch: {
    dialog() {
      let lang = localStorage.getItem("lang");
      if (lang != undefined && lang != null && lang != "") {
        this.langGroup = this.langs.findIndex((x) => x.id === lang);
      }
    },
  },
};
</script>
